import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IPais, IPaisRequest } from '../interfaces/pais.interface';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PaisService {
  private apiUrl = environment.apiNewBackBaseUrl;

  constructor(private http: HttpClient) {}

  getPaises(): Observable<any> {
    const request: IPaisRequest = {
      que: 4,
      tope: '999',
      cmd: '',
      clave_Pais: '',
      descripcion: '',
      clave_Moneda: ''
    };

    return this.http.post<any>(`${this.apiUrl}Paises/cmspa_PaisList`, request);
  }

  getPaisDetail(clave_Pais: string): Observable<any> {
    const request: IPaisRequest = {
      que: 5,
      tope: '',
      cmd: '',
      clave_Pais: clave_Pais,
      descripcion: '',
      clave_Moneda: ''
    };

    return this.http.post<any>(`${this.apiUrl}Paises/cmspa_PaisListDet`, request);
  }

  savePais(data: IPais): Observable<any> {
    const request: IPaisRequest = {
      que: 1,
      tope: '',
      cmd: '',
      clave_Pais: data.clave_Pais,
      descripcion: data.descripcion,
      clave_Moneda: data.moneda
    };

    return this.http.post<any>(`${this.apiUrl}Paises/cmspa_PaisAdd`, request);
  }

  updatePais(data: IPais): Observable<any> {
    const request: IPaisRequest = {
      que: 2,
      tope: '',
      cmd: '',
      clave_Pais: data.clave_Pais,
      descripcion: data.descripcion,
      clave_Moneda: data.moneda
    };

    return this.http.post<any>(`${this.apiUrl}Paises/cmspa_PaisUpd`, request);
  }

  deletePais(clave_Pais: string): Observable<any> {
    const request: IPaisRequest = {
      que: 3,
      tope: '',
      cmd: '',
      clave_Pais: clave_Pais,
      descripcion: '',
      clave_Moneda: ''
    };

    return this.http.post<any>(`${this.apiUrl}Paises/cmspa_PaisDelete`, request);
  }
} 